export const drugs = [
  { value: 'Frozen', text: 'Frozen' },
  { value: 'Chilled', text: 'Chilled' },
  { value: 'Room Temperature', text: 'Room Temperature' },
]
export const medical = [
  { value: 'Frozen', text: 'Frozen' },
  { value: 'Chilled', text: 'Chilled' },
  { value: 'Room Temperature', text: 'Room Temperature' },
  { value: 'Cold Storage', text: 'Cold Storage' },
  { value: 'No Heat Exposure', text: 'No Heat Exposure' },
]
export const food = [
  { value: 'Frozen', text: 'Frozen' },
  { value: 'Chilled', text: 'Chilled' },
  { value: 'Dry', text: 'Dry' },
  {
    value: 'Chilled Vegetables and Fruits',
    text: 'Chilled Vegetables and Fruits',
  },
]
export const plateTypes = [
  { value: 'Private Car', text: 'Private Car' },
  { value: 'Public Transport', text: 'Public Transport' },
  { value: 'Private Transport', text: 'Private Transport' },
  { value: 'Public Minibus', text: 'Public Minibus' },
  { value: 'Private Minibus', text: 'Private Minibus' },
  { value: 'Taxi', text: 'Taxi' },
  {
    value: 'Heavy Equipment-Public Works',
    text: 'Heavy Equipment-Public Works',
  },
  { value: 'Export', text: 'Export' },
  { value: 'Diplomatic', text: 'Diplomatic' },
  { value: 'Motorcycle', text: 'Motorcycle' },
  { value: 'Temporary', text: 'Temporary' },
]
export const fodder = [{ value: 'Fodder', text: 'Fodder' }]
export const pesticides = [{ value: 'Pesticides', text: 'Pesticides' }]

export const aryIannaTimeZones = [
  { text: 'Etc/GMT+12 (UTC-12:00)', value: 'Etc/GMT+12 (UTC-12:00)' },
  {
    text: 'Pacific/Pago_Pago (UTC-11:00)',
    value: 'Pacific/Pago_Pago (UTC-11:00)',
  },
  {
    text: 'Pacific/Pitcairn (UTC-08:00)',
    value: 'Pacific/Pitcairn (UTC-08:00)',
  },
  {
    text: 'America/Metlakatla (UTC-08:00)',
    value: 'America/Metlakatla (UTC-08:00)',
  },
  { text: 'Pacific/Samoa (UTC-11:00)', value: 'Pacific/Samoa (UTC-11:00)' },
  { text: 'America/Yakutat (UTC-08:00)', value: 'America/Yakutat (UTC-08:00)' },
  { text: 'America/Juneau (UTC-08:00)', value: 'America/Juneau (UTC-08:00)' },
  { text: 'US/Alaska (UTC-08:00)', value: 'US/Alaska (UTC-08:00)' },
  { text: 'Etc/GMT+8 (UTC-08:00)', value: 'Etc/GMT+8 (UTC-08:00)' },
  { text: 'US/Aleutian (UTC-09:00)', value: 'US/Aleutian (UTC-09:00)' },
  { text: 'America/Adak (UTC-09:00)', value: 'America/Adak (UTC-09:00)' },
  { text: 'SystemV/YST9 (UTC-09:00)', value: 'SystemV/YST9 (UTC-09:00) ' },
  { text: 'Etc/GMT+9 (UTC-09:00)', value: 'Etc/GMT+9 (UTC-09:00)' },
  { text: 'America/Atka (UTC-09:00)', value: 'America/Atka (UTC-09:00)' },
  {
    text: 'Pacific/Marquesas (UTC-09:30)',
    value: 'Pacific/Marquesas (UTC-09:30)',
  },
  { text: 'Pacific/Gambier (UTC-09:00)', value: 'Pacific/Gambier (UTC-09:00)' },
  { text: 'SystemV/HST10 (UTC-10:00)', value: 'SystemV/HST10 (UTC-10:00)' },
  { text: 'Etc/GMT+10 (UTC-10:00) ', value: 'Etc/GMT+10 (UTC-10:00)' },
  { text: 'US/Hawaii (UTC-10:00)', value: 'US/Hawaii (UTC-10:00)' },
  {
    text: 'Pacific/Johnston (UTC-10:00)',
    value: 'Pacific/Johnston (UTC-10:00)',
  },
  { text: 'Pacific/Tahiti (UTC-10:00)', value: 'Pacific/Tahiti (UTC-10:00)' },
  {
    text: 'Pacific/Rarotonga (UTC-10:00)',
    value: 'Pacific/Rarotonga (UTC-10:00)',
  },
  {
    text: 'Pacific/Honolulu (UTC-10:00)',
    value: 'Pacific/Honolulu (UTC-10:00)',
  },
  { text: 'Etc/GMT+11 (UTC-11:00)', value: 'Etc/GMT+11 (UTC-11:00)' },
  { text: 'US/Samoa (UTC-11:00)', value: 'US/Samoa (UTC-11:00)' },
  { text: 'Pacific/Niue (UTC-11:00)', value: 'Pacific/Niue (UTC-11:00)' },

  { text: 'Canada/Yukon (UTC-07:00)', value: 'Canada/Yukon (UTC-07:00)' },
  { text: 'SystemV/PST8 (UTC-08:00))', value: 'SystemV/PST8 (UTC-08:00)' },
  { text: 'SystemV/YST9YDT (UTC-08:00)', value: 'SystemV/YST9YDT (UTC-08:00)' },
  { text: 'America/Nome (UTC-08:00)', value: 'America/Nome (UTC-08:00)' },
  {
    text: 'America/Anchorage (UTC-08:00)',
    value: 'America/Anchorage (UTC-08:00)',
  },

  { text: 'US/Pacific-New (UTC-07:00)', value: 'US/Pacific-New (UTC-07:00)' },
  { text: 'Canada/Pacific (UTC-07:00)', value: 'Canada/Pacific (UTC-07:00)' },
  { text: 'Etc/GMT+7 (UTC-07:00)', value: 'Etc/GMT+7 (UTC-07:00)' },
  {
    text: 'America/Anchorage (UTC-08:00)',
    value: 'America/Anchorage (UTC-08:00)',
  },
  {
    text: 'America/Dawson_Creek (UTC-07:00)',
    value: 'America/Dawson_Creek (UTC-07:00)',
  },
  { text: 'US/Arizona (UTC-07:00)', value: 'US/Arizona (UTC-07:00)' },
  { text: 'PST8PDT (UTC-07:00)', value: 'PST8PDT (UTC-07:00)' },
  {
    text: 'Mexico/BajaNorte (UTC-07:00)',
    value: 'Mexico/BajaNorte (UTC-07:00)',
  },
  { text: 'SystemV/MST7 (UTC-07:00)', value: 'SystemV/MST7 (UTC-07:00))' },
  { text: 'America/Dawson (UTC-07:00)', value: 'America/Dawson (UTC-07:00)' },

  {
    text: 'America/Santa_Isabel (UTC-07:00)',
    value: 'America/Santa_Isabel (UTC-07:00)',
  },
  {
    text: 'America/Hermosillo (UTC-07:00)',
    value: 'America/Hermosillo (UTC-07:00)',
  },
  { text: 'America/Creston (UTC-07:00)', value: 'America/Creston (UTC-07:00)' },
  { text: 'America/Tijuana (UTC-07:00)', value: 'America/Tijuana (UTC-07:00)' },

  { text: 'SystemV/PST8PDT (UTC-07:00)', value: 'SystemV/PST8PDT (UTC-07:00)' },
  { text: 'America/Tijuana (UTC-07:00)', value: 'America/Tijuana (UTC-07:00)' },
  {
    text: 'America/Fort_Nelson (UTC-07:00)',
    value: 'America/Fort_Nelson (UTC-07:00)',
  },
  {
    text: 'America/Whitehorse (UTC-07:00)',
    value: 'America/Whitehorse (UTC-07:00)',
  },
  { text: 'America/Phoenix (UTC-07:00)', value: 'America/Phoenix (UTC-07:00)' },
  {
    text: 'America/Ensenada (UTC-07:00)',
    value: 'America/Ensenada (UTC-07:00)',
  },
  {
    text: 'America/Vancouver (UTC-07:00)',
    value: 'America/Vancouver (UTC-07:00)',
  },

  { text: 'America/Belize (UTC-06:00)', value: 'America/Belize (UTC-06:00)' },
  {
    text: 'America/Guatemala (UTC-06:00)',
    value: 'America/Guatemala (UTC-06:00)',
  },
  {
    text: 'America/El_Salvador (UTC-06:00)',
    value: 'America/El_Salvador (UTC-06:00)',
  },
  { text: 'US/Pacific (UTC-07:00)', value: 'US/Pacific (UTC-07:00)' },
  {
    text: 'America/Los_Angeles (UTC-07:00)',
    value: 'America/Los_Angeles (UTC-07:00)',
  },

  { text: 'SystemV/CST6 (UTC-06:00)', value: 'SystemV/CST6 (UTC-06:00)' },
  { text: 'MST7MDT (UTC-06:00)', value: 'MST7MDT (UTC-06:00)' },
  {
    text: 'America/Yellowknife (UTC-06:00)',
    value: 'America/Yellowknife (UTC-06:00)',
  },
  {
    text: 'Pacific/Galapagos (UTC-06:00)',
    value: 'Pacific/Galapagos (UTC-06:00)',
  },
  { text: 'Mexico/BajaSur (UTC-06:00)', value: 'Mexico/BajaSur (UTC-06:00)' },
  { text: 'Canada/Central (UTC-05:00)', value: 'Canada/Central (UTC-05:00)' },
  { text: 'Pacific/Easter (UTC-06:00)', value: 'Pacific/Easter (UTC-06:00)' },
  { text: 'Etc/GMT+6 (UTC-06:00)', value: 'Etc/GMT+6 (UTC-06:00)' },
  {
    text: 'America/Tegucigalpa (UTC-06:00)',
    value: 'America/Tegucigalpa (UTC-06:00)',
  },
  { text: 'America/Managua (UTC-06:00)', value: 'America/Managua (UTC-06:00)' },

  { text: 'Etc/GMT+2 (UTC-02:00)', value: 'Etc/GMT+2 (UTC-02:00)' },
  {
    text: 'Atlantic/Stanley (UTC-03:00)',
    value: 'Atlantic/Stanley (UTC-03:00)',
  },
  {
    text: 'Atlantic/Bermuda (UTC-03:00)',
    value: 'Atlantic/Bermuda (UTC-03:00)',
  },
  { text: 'US/Eastern (UTC-04:00)', value: 'US/Eastern (UTC-04:00)' },
  {
    text: 'Chile/Continental (UTC-04:00)',
    value: 'Chile/Continental (UTC-04:00)',
  },
  { text: 'CST6CDT (UTC-05:00)', value: 'CST6CDT (UTC-05:00)' },
  { text: 'Mexico/General (UTC-05:00)', value: 'Mexico/General (UTC-05:00)' },
  { text: 'America/Chicago (UTC-05:00)', value: 'America/Chicago (UTC-05:00)' },
  { text: 'Navajo (UTC-06:00)', value: 'Navajo (UTC-06:00)' },
  { text: 'Canada/Mountain (UTC-06:00)', value: 'Canada/Mountain (UTC-06:00)' },
  {
    text: 'Chile/EasterIsland (UTC-06:00)',
    value: 'Chile/EasterIsland (UTC-06:00)',
  },

  { text: 'Pacific/Fakaofo (UTC+13:00)', value: 'Pacific/Fakaofo (UTC+13:00)' },
  { text: 'Etc/GMT-14 (UTC+14:00)', value: 'Etc/GMT-14 (UTC+14:00)' },
  {
    text: 'Atlantic/Cape_Verde (UTC-01:00)',
    value: 'Atlantic/Cape_Verde (UTC-01:00)',
  },
  { text: 'Etc/GMT+1 (UTC-01:00)', value: 'Etc/GMT+1 (UTC-01:00)' },
  {
    text: 'America/St_Johns (UTC-02:30)',
    value: 'America/St_Johns (UTC-02:30)',
  },

  {
    text: 'Pacific/Port_Moresby (UTC+10:00)',
    value: 'Pacific/Port_Moresby (UTC+10:00)',
  },
  {
    text: 'America/St_Johns (UTC-02:30)',
    value: 'America/St_Johns (UTC-02:30)',
  },
  {
    text: 'Australia/Lord_Howe (UTC+10:30)',
    value: 'Australia/Lord_Howe (UTC+10:30)',
  },
  { text: 'Etc/GMT-11 (UTC+11:00)', value: 'Etc/GMT-11 (UTC+11:00)' },
  { text: 'Pacific/Ponape (UTC+11:00)', value: 'Pacific/Ponape (UTC+11:00)' },
  {
    text: 'Pacific/Kwajalein (UTC+12:00)',
    value: 'Pacific/Kwajalein (UTC+12:00)',
  },
  { text: 'NZ-CHAT (UTC+12:45)', value: 'NZ-CHAT (UTC+12:45)' },

  { text: 'Australia/North (UTC+09:30)', value: 'Australia/North (UTC+09:30)' },
  { text: 'Etc/GMT-8 (UTC+08:00)', value: 'Etc/GMT-8 (UTC+08:00)' },
  { text: 'Australia/Eucla (UTC+08:45)', value: 'Australia/Eucla (UTC+08:45)' },
  { text: 'Japan (UTC+09:00)', value: 'Japan (UTC+09:00)' },
  { text: 'Etc/GMT-9 (UTC+09:00)', value: 'Etc/GMT-9 (UTC+09:00)' },

  { text: 'Asia/Samarkand (UTC+05:00)', value: 'Asia/Samarkand (UTC+05:00)' },
  { text: 'Asia/Colombo (UTC+05:30)', value: 'Asia/Colombo (UTC+05:30)' },
  { text: 'Asia/Kathmandu (UTC+05:45)', value: 'Asia/Kathmandu (UTC+05:45)' },
  {
    text: 'Asia/Krasnoyarsk (UTC+07:00)',
    value: 'Asia/Krasnoyarsk (UTC+07:00)',
  },
  { text: 'Asia/Singapore (UTC+08:00)', value: 'Asia/Singapore (UTC+08:00)' },
  { text: 'PRC (UTC+08:00)', value: 'PRC (UTC+08:00)' },
  { text: 'Asia/Kuching (UTC+08:00)', value: 'Asia/Kuching (UTC+08:00)' },

  { text: 'Europe/Istanbul (UTC+03:00)', value: 'Europe/Istanbul (UTC+03:00)' },
  { text: 'Asia/Aden (UTC+03:00)', value: 'Asia/Aden (UTC+03:00)' },
  { text: 'Asia/Dubai (UTC+04:00)', value: 'Asia/Dubai (UTC+04:00)' },
  { text: 'Etc/GMT-4 (UTC+04:00) ', value: 'Etc/GMT-4 (UTC+04:00) )' },
  { text: 'Asia/Kabul (UTC+04:30)', value: 'Asia/Kabul (UTC+04:30)' },
  { text: 'Asia/Tehran (UTC+04:30)', value: 'Asia/Tehran (UTC+04:30)' },
  { text: 'Iran (UTC+04:30)', value: 'Iran (UTC+04:30)' },

  {
    text: 'Europe/Bucharest (UTC+03:00)',
    value: 'Europe/Bucharest (UTC+03:00)',
  },
  {
    text: 'Africa/Mogadishu (UTC+03:00)',
    value: 'Africa/Mogadishu (UTC+03:00)',
  },
  {
    text: 'Africa/Addis_Ababa (UTC+03:00)',
    value: 'Africa/Addis_Ababa (UTC+03:00)',
  },
  { text: 'Europe/Moscow (UTC+03:00)', value: 'Europe/Moscow (UTC+03:00)' },
  { text: 'Asia/Kuwait (UTC+03:00)', value: 'Asia/Kuwait (UTC+03:00)' },
  { text: 'Asia/Gaza (UTC+03:00)', value: 'Asia/Gaza (UTC+03:00)' },
  { text: 'Indian/Reunion (UTC+04:00)', value: 'Indian/Reunion (UTC+04:00)' },
  { text: 'Etc/GMT-3 (UTC+03:00)', value: 'Etc/GMT-3 (UTC+03:00)' },

  { text: 'Asia/Bahrain (UTC+03:00)', value: 'Asia/Bahrain (UTC+03:00)' },
  { text: 'Turkey (UTC+03:00)', value: 'Turkey (UTC+03:00)' },
  { text: 'Asia/Qatar (UTC+03:00)', value: 'Asia/Qatar (UTC+03:00)' },
  { text: 'Asia/Riyadh (UTC+03:00)', value: 'Asia/Riyadh (UTC+03:00)' },
  {
    text: 'Africa/Dar_es_Salaam (UTC+03:00)',
    value: 'Africa/Dar_es_Salaam (UTC+03:00)',
  },
  { text: 'Asia/Damascus (UTC+03:00)', value: 'Asia/Damascus (UTC+03:00)' },
  { text: 'Asia/Beirut (UTC+03:00)', value: 'Asia/Beirut (UTC+03:00)' },
  { text: 'Asia/Istanbul (UTC+03:00)', value: 'Asia/Istanbul (UTC+03:00)' },

  { text: 'CET (UTC+02:00)', value: 'CET (UTC+02:00)' },
  { text: 'Europe/Malta (UTC+02:00)', value: 'Europe/Malta (UTC+02:00)' },
  { text: 'Etc/GMT-2 (UTC+02:00)', value: 'Etc/GMT-2 (UTC+02:00))' },
  { text: 'Africa/Cairo (UTC+02:00)', value: 'Africa/Cairo (UTC+02:00)' },
  { text: 'Libya (UTC+02:00)', value: 'Libya (UTC+02:00)' },
  { text: 'Asia/Amman (UTC+03:00)', value: 'Asia/Amman (UTC+03:00)' },
  { text: 'Africa/Juba (UTC+03:00)', value: 'Africa/Juba (UTC+03:00)' },

  { text: 'Europe/Budapest (UTC+02:00)', value: 'Europe/Budapest (UTC+02:00)' },
  { text: 'Europe/Vienna (UTC+02:00)', value: 'Europe/Vienna (UTC+02:00)' },
  { text: 'Europe/Paris (UTC+02:00)', value: 'Europe/Paris (UTC+02:00)' },
  {
    text: 'Europe/Stockholm (UTC+02:00)',
    value: 'Europe/Stockholm (UTC+02:00)',
  },
  { text: 'Europe/Zurich (UTC+02:00)', value: 'Europe/Zurich (UTC+02:00)' },
  { text: 'Europe/Berlin (UTC+02:00)', value: 'Europe/Berlin (UTC+02:00)' },
  { text: 'Europe/Rome (UTC+02:00)', value: 'Europe/Rome (UTC+02:00)' },

  { text: 'Europe/Monaco (UTC+02:00)', value: 'Europe/Monaco (UTC+02:00)' },
  { text: 'Africa/Tunis (UTC+01:00)', value: 'Africa/Tunis (UTC+01:00)' },
  { text: 'Egypt (UTC+02:00)', value: 'Egypt (UTC+02:00)' },
  {
    text: 'Africa/Khartoum (UTC+02:00))',
    value: 'Africa/Khartoum (UTC+02:00)',
  },
  {
    text: 'Africa/Johannesburg (UTC+02:00)',
    value: 'Africa/Johannesburg (UTC+02:00)',
  },
  { text: 'Etc/GMT-1 (UTC+01:00)', value: 'Etc/GMT-1 (UTC+01:00)' },
  { text: 'Europe/Madrid (UTC+02:00)', value: 'Europe/Madrid (UTC+02:00)' },
  { text: 'Poland (UTC+02:00)', value: 'Poland (UTC+02:00)' },
  {
    text: 'Europe/Copenhagen (UTC+02:00)',
    value: 'Europe/Copenhagen (UTC+02:00)',
  },
  { text: 'Africa/Kigali (UTC+02:00)', value: 'Africa/Kigali (UTC+02:00)' },
  {
    text: 'Europe/Luxembourg (UTC+02:00)',
    value: 'Europe/Luxembourg (UTC+02:00)',
  },

  { text: 'Africa/Luanda (UTC+01:00)', value: 'Africa/Luanda (UTC+01:00)' },
  { text: 'Africa/Algiers (UTC+01:00)', value: 'Africa/Algiers (UTC+01:00)' },
  { text: 'Africa/Douala (UTC+01:00)', value: 'Africa/Douala (UTC+01:00)' },
  { text: 'Etc/UTC (UTC+00:00)', value: 'Etc/UTC (UTC+00:00)' },
  { text: 'Europe/Dublin (UTC+01:00)', value: 'Europe/Dublin (UTC+01:00)' },
  { text: 'Portugal (UTC+01:00)', value: 'Portugal (UTC+01:00)' },
]
